import { useRef, useState } from 'react';
import { useBusinessAction } from './useBusinessAction';
import { useBusinessList } from './useBusinessResource';
import { creditLimit, requestKey } from './businessSettingsHelpers';

export function useBusinessLimitRequests({ api, workspaceId, mineOnly = false, changed }) {
  const rows = useBusinessList((after, options) => api.limitRequests(workspaceId, { after, limit: 25, ...(mineOnly ? { scope: 'mine' } : {}) }, options), [workspaceId, mineOnly]);
  const [amount, setAmount] = useState(''), [reason, setReason] = useState('');
  const key = useRef(null), action = useBusinessAction();
  const submit = event => { event?.preventDefault?.(); return action.run(async options => {
    if (!/^\d+$/.test(amount.trim())) throw new Error('Enter a whole number of credits.');
    const requestedLimitCredits = creditLimit(amount);
    if (requestedLimitCredits <= rows.currentLimitCredits) throw new Error('Request a limit higher than your current limit.');
    if (!reason.trim() || reason.trim().length > 500) throw new Error('Explain why you need a higher limit in up to 500 characters.');
    const body = { requestedLimitCredits, reason: reason.trim() }, signature = JSON.stringify(body);
    if (key.current?.signature !== signature) key.current = { signature, value: requestKey() };
    await api.requestLimit(workspaceId, body, key.current.value, options);
    if (action.current()) { key.current = null; setAmount(''); setReason(''); rows.refresh(); }
  }, 'Your request was sent for review.'); };
  const decide = (row, decision) => action.run(async options => {
    if (decision === 'withdraw') await api.withdrawLimit(workspaceId, row.id, options);
    else await api.decideLimit(workspaceId, row.id, decision, options);
    if (action.current()) { rows.refresh(); changed?.(); }
  }, decision === 'approve' ? 'The member’s limit was updated.' : decision === 'deny' ? 'The request was denied.' : 'Your request was withdrawn.');
  return { rows, amount, setAmount, reason, setReason, action, submit, decide, disabled: action.busy || rows.loading || !!rows.error };
}
